// TODO: Replace with library to handle more scenarios
export const pluralizeWord = (count: number, singularWord: string): string =>
  singularWord + (Math.abs(count) == 1 ? '' : 's')

export const pluralize = (count: number, singularWord: string): string =>
  `${count} ${pluralizeWord(count, singularWord)}`
